"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var constants_1 = require("../../constants");
var useGetSuggestionHref_1 = __importDefault(require("../../hooks/useGetSuggestionHref"));
var SearchBarContext_1 = require("../../SearchBarContext");
var utils_1 = require("../../utils");
function SuggestionLink(_a) {
    var children = _a.children, defaultSuggestion = _a.defaultSuggestion, handleDefaultSuggestionClicked = _a.handleDefaultSuggestionClicked, onClick = _a.onClick, props = __rest(_a, ["children", "defaultSuggestion", "handleDefaultSuggestionClicked", "onClick"]);
    var _b = (0, SearchBarContext_1.useSearchBarContext)(), customEventData = _b.customEventData, noResults = _b.noResults, onSuggestionSelection = _b.onSuggestionSelection;
    var getSuggestionUrl = (0, useGetSuggestionHref_1.default)();
    var eventData = (0, react_1.useMemo)(function () {
        var _a;
        return (__assign(__assign({}, customEventData), { buildKey: null, suggestionIndex: null, suggestionsLength: noResults ? 0 : null, suggestionText: (_a = defaultSuggestion === null || defaultSuggestion === void 0 ? void 0 : defaultSuggestion.text) !== null && _a !== void 0 ? _a : '', textEntered: '', textSource: constants_1.SearchType.DefaultSuggestion }));
    }, [customEventData, defaultSuggestion === null || defaultSuggestion === void 0 ? void 0 : defaultSuggestion.text, noResults]);
    var href = (0, react_1.useMemo)(function () {
        var _a;
        return (_a = props.href) !== null && _a !== void 0 ? _a : getSuggestionUrl((0, utils_1.generateUrlWithFilters)(defaultSuggestion.filters), eventData);
    }, [defaultSuggestion.filters, eventData, getSuggestionUrl, props.href]);
    var handleOnClick = (0, react_1.useCallback)(function (e) {
        handleDefaultSuggestionClicked(e, defaultSuggestion === null || defaultSuggestion === void 0 ? void 0 : defaultSuggestion.text);
        if (onSuggestionSelection) {
            e.preventDefault();
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
            onSuggestionSelection({
                cvnaId: (0, utils_1.encodeAndStringify)(defaultSuggestion === null || defaultSuggestion === void 0 ? void 0 : defaultSuggestion.filters),
                url: href,
                eventData: eventData
            });
        }
    }, [
        defaultSuggestion === null || defaultSuggestion === void 0 ? void 0 : defaultSuggestion.filters,
        defaultSuggestion === null || defaultSuggestion === void 0 ? void 0 : defaultSuggestion.text,
        eventData,
        handleDefaultSuggestionClicked,
        href,
        onClick,
        onSuggestionSelection
    ]);
    return (
    // eslint-disable-next-line local-rules/on-click-analytics-id
    react_1.default.createElement("a", __assign({}, props, { href: href, onClick: handleOnClick, "data-native-included": "false" }), children));
}
exports.default = SuggestionLink;
//# sourceMappingURL=SuggestionLink.js.map